<template>
  <!-- <div class="txt3"> -->
    <div class="txt text-secondary">
    <div class="w-100 p-3 text-dark bg-ligth"></div> 
      <b-container>
      <b-row class="text-center">
        <b-col><h1 class="text-center">Contacto</h1></b-col>
        <b-col col lg="8"><modal :identificador="3"/></b-col>
      </b-row>
      </b-container>
  <!--
    <h1>Contacto</h1>
    <modal :identificador="3"/>
-->
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-form-group
        id="input-group-1" label="" label-for="input-1">
        Email: 
        <b-form-input
          id="input-1"
          v-model="form.email"
          placeholder=""
          type="text"

        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2" label="" label-for="input-2">
        Nombre:
        <b-form-input
          id="input-2"
          v-model="form.name"
          placeholder=""
          type="text"

        ></b-form-input>
        <p></p> 
      </b-form-group>
      <b-button class="button1" type="submit" variant="primary">Enviar</b-button>
      <b-button type="reset" variant="secondary">Reset</b-button>

</b-form>


  </div>
</template>

<script>
import Modal from './Modal.vue'
  export default {
  components: { Modal },
    data() {
      return {
        form: {
          email: '',
          name: '',
        },
        show: true
      }
    },
    methods: {
      onSubmit(event) {
        event.preventDefault()
        alert(JSON.stringify(this.form))
      },
      onReset(event) {
        event.preventDefault()
        // Reset our form values
        this.form.email = ''
        this.form.name = ''
        // Trick to reset/clear native browser form validation state
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      }
    }
  }
</script>

<style>
.txt3 {

 /* margin-left: 5%;
  margin-right: 5%;
  text-align: left;
  margin-block-end: 4%; */

  color:grey;

  /*
    margin-top: 4%;
    margin-left: 25%;
    text-align: center;
    width: 50%;
    height: 200px;
    margin-block-end: 5%;
*/
}
.button1{
 margin-right:2%;
}
</style>
